import * as React from 'react';
import * as styles from './styles.css';
import cn from 'clsx';

import { ConditionalWrapper } from '@cian/conditional-component';
/**
 * @todo move from deprecated typography to new one
 * @see {@link https://jira.cian.tech/browse/CD-163108}
 */
import { Header0, ArticleHeading1, UIText1, Button, useDeviceType } from '@cian/ui-kit';

import { PolicyAgreement } from '../PolicyAgreement';
import { formContextObj } from '../../containers/FormContainer';
import { ENamePartners } from '../../constants/namePartners';

interface IPartnerIntro {
  partner: ENamePartners;
}

export const PartnerIntro: React.FC<React.PropsWithChildren<IPartnerIntro>> = ({ partner }) => {
  const { startQuiz } = React.useContext(formContextObj);
  const deviceType = useDeviceType();
  const isMobile = deviceType !== 'desktop';

  return (
    <div className={styles['container']}>
      <div>
        {isMobile && <div className={styles['img']} />}
        <div
          className={cn(styles['logo'], {
            [styles['logo_n1']]: partner === ENamePartners.N1,
            [styles['logo_bankiru']]: partner === ENamePartners.Bankiru,
          })}
        />
        <div className={styles['title']}>
          <ConditionalWrapper if={isMobile} ThenComponent={ArticleHeading1} ElseComponent={Header0}>
            {`Циан и ${partner} бесплатно помогут подобрать риелтора`}
          </ConditionalWrapper>
        </div>
        <ul className={styles['list']}>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <UIText1>1</UIText1>
            </span>
            <UIText1>Заполните анкету за пару минут</UIText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <UIText1>2</UIText1>
            </span>
            <UIText1>Мы отправим её риелторам-партнёрам</UIText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <UIText1>3</UIText1>
            </span>
            <UIText1>Вам позвонят 3 кандидата — не больше</UIText1>
          </li>
          <li className={styles['list-item']}>
            <span className={styles['marker']}>
              <UIText1>4</UIText1>
            </span>
            <UIText1>Обсудите условия и выберите своего риелтора</UIText1>
          </li>
        </ul>
        <div className={styles['button-sticky']} data-testid="quizStart">
          <Button theme="fill_primary" size="M" onClick={startQuiz} fullWidth={isMobile}>
            Заполнить анкету
          </Button>
        </div>
      </div>
      {isMobile && (
        <div className={styles['footer']}>
          <PolicyAgreement />
        </div>
      )}
    </div>
  );
};

PartnerIntro.displayName = 'PartnerIntro';
